import React from "react";
import NodataGif from "../../../resources/images/page-not-found.gif"
const  PageNotFound= () => {
  return (

        <div style={{width:"100%"}}>
          <img
            src={NodataGif}
            alt="noData Found"
            style={{width:"100%"}}
          />
        </div>
  );
};
export default PageNotFound;